export * from './validation-method-selection/validation-method-selection.component';
export * from './capture-fingerprint/capture-fingerprint.component';
export * from './capture-face/capture-face.component';
